var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxPlusAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M10.612 18.763a8.145 8.145 0 002.133 2.294l-1.564.896a.382.382 0 01-.561-.253l-.008-.076v-2.861zM1.498 8.179l.07.032 7.629 4.368c.094.054.16.145.182.25l.009.08v8.715a.378.378 0 01-.498.361l-.07-.03-7.629-4.362a.38.38 0 01-.182-.25L1 17.263V8.54a.38.38 0 01.498-.361zM17.5 8a6.501 6.501 0 010 13 6.501 6.501 0 010-13zm.55 2.57h-1.1a.558.558 0 00-.55.563v2.25h-2.2a.558.558 0 00-.55.562v1.125c0 .31.248.563.55.563h2.2v2.25c0 .309.248.562.55.562h1.1c.302 0 .55-.253.55-.563v-2.25h2.2c.302 0 .55-.253.55-.562v-1.125a.558.558 0 00-.55-.563h-2.2v-2.25a.558.558 0 00-.55-.562zm-7.935-8.553l.072.031 7.63 4.352.012.007a8.105 8.105 0 00-7.844 5.065.297.297 0 01-.11-.016l-.072-.032L2.18 7.067a.38.38 0 01-.062-.615l.062-.045 7.63-4.358a.377.377 0 01.304-.032z"
  }))));
}

export default SvgBoxPlusAlt;